import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { BrowserRouter as Router, Route } from 'react-router-dom';
import { IconSettings } from '@salesforce/design-system-react';
import App from './App';
import Listing from './App/Listing';
import './index.css';

ReactDOM.render(
	<Router>
		<IconSettings iconPath="/assets/icons">
			<Route exact path="/" component={Listing} />
			<Route exact path="/demos" component={Listing} />
			<Route path="/demo/:flow" component={App} />
		</IconSettings>
	</Router>,
	document.getElementById('root') as HTMLElement
);



// WEBPACK FOOTER //
// ./src/index.tsx